
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sanctuary/celestial-binding",
      function () {
        return require("private-next-pages/sanctuary/celestial-binding.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sanctuary/celestial-binding"])
      });
    }
  